// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__eLnec","textarea":"styles_textarea__2dHlE"};